import { render, staticRenderFns } from "./select3DText.vue?vue&type=template&id=743bb2c7&"
import script from "./select3DText.vue?vue&type=script&lang=ts&"
export * from "./select3DText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports